export default __webpack_public_path__ + "static/media/parking-management-system.f51edbd5.jpg";